module.exports = __webpack_public_path__ + "img/header-01.7f4a6140.png";